import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import OwnerType from "@/utils/constants/OwnerType.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NaMaMetaData = namaTypes.NaMaMetaData;
import FieldMetaData = namaTypes.FieldMetaData;
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class QuestionListHandler extends EditableGridHandler {
    private _targetColumnMetaData: FieldMetaData;
    private _column: EditScreenGridColumn

    constructor(gridId: string, presenter: WidgetsPresenter, targetColumnMetaData: FieldMetaData, column: EditScreenGridColumn) {
        super(gridId, presenter);
        this._targetColumnMetaData = targetColumnMetaData;
        this._column = column;
    }

  override get presenter(): QuestionFieldsPresenter {
    return this._presenter as QuestionFieldsPresenter;
  }

  override get metadata() {
    let fieldsMetaData = [this.targetColumnMetaData];
    if (this.targetColumnMetaData.fieldType === FieldType.Reference) {
      fieldsMetaData.push({
        id: this.targetColumnMetaData.id + "." + CommonFieldIds.CODE,
        fieldId: this.targetColumnMetaData.id + "." + CommonFieldIds.CODE,
        fieldType: FieldType.Text
      });
    }
    return {
      owner: {
        ownerId: '',
        ownerType: OwnerType.Entity
      },
      fieldsMetaData: fieldsMetaData
    } as NaMaMetaData;
  }

    get targetColumnMetaData(): namaTypes.FieldMetaData {
        return this._targetColumnMetaData;
    }

    set targetColumnMetaData(value: namaTypes.FieldMetaData) {
        this._targetColumnMetaData = value;
    }

    get column(): namaTypes.EditScreenGridColumn {
        return this._column;
    }

    set column(value: namaTypes.EditScreenGridColumn) {
        this._column = value;
    }

    override listVisibleColumns(): EditScreenGridColumn[] {
        return [this.column];
    }
}
